import { IPhoto } from "../types";

const categoryNames: Record<string, string> = {
  newborn: "Newborn portrait",
  maternity: "Maternity portrait",
  baby: "Baby portrait",
  family: "Family portrait",
  woman: "Women’s portrait",
  discharge: "Hospital newborn portrait",
  christening: "Christening portrait",
};

export const getPhotoAlt = (photo?: IPhoto, imageIndex = 0): string => {
  if (!photo) {
    return "Photography portrait by Alena Lobacheva in Charlotte, NC";
  }

  const providedAlt = photo.alt?.trim();
  if (providedAlt) return providedAlt;

  const categoryName = categoryNames[photo.type] || "Photography portrait";
  const position = photo.order || imageIndex + 1;
  return `${categoryName}, portfolio image ${position}`;
};
